import { UseCaseInteractor } from '../../../kernel/use-case'
import { AddItemsRepository } from '../domain/add-items.repository'
import { BodyToAddItems, AddItemsResponse } from '../domain/entities'

export const addItemsUseCase: UseCaseInteractor<[AddItemsRepository], [payload: BodyToAddItems], AddItemsResponse> =
  (reAssignaDataRepository) => async (payload) => {
    return reAssignaDataRepository.addItems(payload)
  }
